import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import ReorderWarehousePurchaseContainer from 'app/containers/InventoryManagement/WarehousePurchase/pages/reorder'

const ReorderWarehousePurchaseContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <ReorderWarehousePurchaseContainer />
    </>
  )
}
const ReorderWarehousePurchaseContainerPage = memo(
  ReorderWarehousePurchaseContainerPageCpn,
  isEqual,
)

export default ReorderWarehousePurchaseContainerPage
